import BirthDateCertifiedForm              from "./BirthDateCertifiedForm"
import CasteMultiple                       from "./CasteMultiple"
import CasteSingle                         from "./CasteSingle"
import CitizenshipCopy                     from "./CitizenshipCopy"
import CompanyRegistration                 from "./CompanyRegistration"
import CourtFeeForm                        from "./CourtFee"
import DalitVerification                   from "./DalitVerification"
import DeathInheritance                    from "./DeathInheritance"
import DharaJadanForm                      from "./DharaJadanSifarish"
import DisabilityProof                     from "./DisabilityProof"
import ElectricityConnection               from "./ElectricityConnection"
import FourCornerCertified                 from "./FourCornerCertified"
import GharJaggaNaamsaari                  from "./GharJaggaNaamsaari"
import HomeCollapsedCertified              from "./HomeCollapsedCertified"
import HomePersist                         from "./HomePersist"
import HomeRoad                            from "./HomeRoad"
import KittakaatForm                       from "./KittakaatSifarish"
import IdentityByBirthDate                 from "./IdentityByBirthDate"
import IdentityByName                      from "./IdentityByName"
import IncomeVerificationForm              from "./IncomeVerification"
import InternalMigration                   from "./InternalMigration"
import LandOwnershipLost                   from "./LandOwnershipLost"
import MarriageCertified                   from "./MarriageCertified"
import NonProfitOrganizationRegisterForm from "./NonProfitOrganizationRegister"
import OrganizationRenew                   from "./OrganizationRenew"
import PermanentAddress                    from "./PermanentAddress"
import PropertyValuationForm               from "./PropertyValuation"
import RecommendationForClassroomOperation from "./RecommendationForClassroomOperation"
import RelationshipCertificateAlive        from "./RelationshipCertificateAlive"
import RelationshipCertificateDeceased     from "./RelationshipCertificateDeceased"
import RelationshipVerificationForm        from "./RelationshipVerification"
import RoadPersist                         from "./RoadPersist"
import RoomEvacuateForm                    from "./RoomEvacuate"
import Scholarship                         from "./Scholarship"
import ScholarshipForPoor                  from "./ScholarshipForPoor"
import SeniorCitizenAllowance              from "./SeniorCitizenAllowance"
import TaxClearanceCertificateForm         from "./TaxClearanceCertificate"
import TemporaryResidence                  from "./TemporaryResidence"
import ThreeGenerationVerification         from "./ThreeGenerationVerification"
import TreatmentAssistance                 from "./TreatmentAssistance"
import UnmarriedCertified                  from "./UnmarriedCertified"
import Blank                               from "./BlankForm"


export default {
    "death-inheritance": {
        form: DeathInheritance,
        print: DeathInheritance,
    },

    "land-ownership-lost": {
        form: LandOwnershipLost,
        print: LandOwnershipLost,
    },

    "home-road": {
        form: HomeRoad,
        print: HomeRoad,
    },

    "disability-proof": {
        form: DisabilityProof,
        print: DisabilityProof,
    },

    "recommendation-for-classroom-operation": {
        form: RecommendationForClassroomOperation,
        print: RecommendationForClassroomOperation,
    },

    "home-collapsed-certified": {
        form: HomeCollapsedCertified,
        print: HomeCollapsedCertified,
    },

    "home-persist": {
        form: HomePersist,
        print: HomePersist,
    },

    "road-persist": {
        form: RoadPersist,
        print: RoadPersist,
    },

    "dalit-verification": {
        form: DalitVerification,
        print: DalitVerification,
    },

    "caste-multiple": {
        form: CasteMultiple,
        print: CasteMultiple,
    },

    "caste-single": {
        form: CasteSingle,
        print: CasteSingle,
    },

    "senior-citizen-allowance": {
        form: SeniorCitizenAllowance,
        print: SeniorCitizenAllowance,
    },

    "organization-renew": {
        form: OrganizationRenew,
        print: OrganizationRenew,
    },

    "three-generation-verification": {
        form: ThreeGenerationVerification,
        print: ThreeGenerationVerification,
    },

    "identity-by-birth-date": {
        form: IdentityByBirthDate,
        print: IdentityByBirthDate,
    },

    "identity-by-name": {
        form: IdentityByName,
        print: IdentityByName,
    },

    "marriage-certified": {
        form: MarriageCertified,
        print: MarriageCertified,
    },

    "ghar-jagga-naamsaari": {
        form: GharJaggaNaamsaari,
        print: GharJaggaNaamsaari,
    },

    "scholarship": {
        form: Scholarship,
        print: Scholarship,
    },

    "scholarship-for-poor": {
        form: ScholarshipForPoor,
        print: ScholarshipForPoor,
    },

    "electricity-connection": {
        form: ElectricityConnection,
        print: ElectricityConnection,
    },

    "temporary-residence": {
        form: TemporaryResidence,
        print: TemporaryResidence,
    },

    "permanent-residence": {
        form: PermanentAddress,
        print: PermanentAddress,
    },

    "relationship-certificate-alive": {
        form: RelationshipCertificateAlive,
        print: RelationshipCertificateAlive,
    },

    "company-registration": {
        form: CompanyRegistration,
        print: CompanyRegistration,
    },

    "internal-migration": {
        form: InternalMigration,
        print: InternalMigration,
    },

    "relationship-certificate-deceased": {
        form: RelationshipCertificateDeceased,
        print: RelationshipCertificateDeceased,
    },

    "four-corner-certified": {
        form: FourCornerCertified,
        print: FourCornerCertified,
    },

    "unmarried-certified": {
        form: UnmarriedCertified,
        print: UnmarriedCertified,
    },

    "birth-date-certified": {
        form: BirthDateCertifiedForm,
        print: BirthDateCertifiedForm,
    },

    "treatment-assistance": {
        form: TreatmentAssistance,
        print: TreatmentAssistance,
    },

    "citizenship-copy": {
        form: CitizenshipCopy,
        print: CitizenshipCopy,
    },
    "kittakaat-sifarish": {
        form: KittakaatForm,
        print: KittakaatForm
    }  ,
    "room-evacuate": {
        form: RoomEvacuateForm,
        print: RoomEvacuateForm                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
    },
    "court-fee": {
        form: CourtFeeForm,
        print: CourtFeeForm
    },
    "non-profit-organization-register":{
        form: NonProfitOrganizationRegisterForm,
        print: NonProfitOrganizationRegisterForm
    },
    "tax-clearance-certificate": {
        form: TaxClearanceCertificateForm,
        print: TaxClearanceCertificateForm
    },
    "income-verification": {
        form: IncomeVerificationForm,
        print: IncomeVerificationForm
    },
    "property-valuation": {
        form: PropertyValuationForm,
        print: PropertyValuationForm
    },
    "dhara-jadan-sifarish": {
        form: DharaJadanForm,
        print: DharaJadanForm
    },
    "relationship-verification": {
        form: RelationshipVerificationForm,
        print: RelationshipVerificationForm
    },
    "blank":{
        form: Blank,
        print: Blank
    }
}
